<template>
  <div class="introvideo-container">
    <div class="inner-content">
      <div class="video-container">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/soXo5bJ-XFs" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroVideo'
}
</script>

<style>
.introvideo-container {
  width: 100%;
  background: var(--light-grey);
  text-align: center;
}
.inner-content {
  max-width: 750px;
  margin: auto;
}
.video-container {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
}
.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
